import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface AuthUser {
  id: number;
  username: string;
  email: string;
  displayName?: string;
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  private currentUserSubject = new BehaviorSubject<AuthUser | null>(null);
  public currentUser$: Observable<AuthUser | null> = this.currentUserSubject.asObservable();

  constructor() {
    // Charger l'utilisateur depuis localStorage au démarrage
    const storedUser = localStorage.getItem('currentUser');
    if (storedUser) {
      try {
        this.currentUserSubject.next(JSON.parse(storedUser));
      } catch (e) {
        console.error('Erreur lors du chargement de l\'utilisateur:', e);
        localStorage.removeItem('currentUser');
      }
    }
  }

  /**
   * Obtenir l'utilisateur actuellement connecté
   */
  getCurrentUser(): AuthUser | null {
    return this.currentUserSubject.value;
  }

  /**
   * Vérifier si un utilisateur est connecté
   */
  isAuthenticated(): boolean {
    return this.currentUserSubject.value !== null;
  }

  /**
   * Définir l'utilisateur connecté
   */
  setUser(user: AuthUser): void {
    this.currentUserSubject.next(user);
    localStorage.setItem('currentUser', JSON.stringify(user));
  }

  /**
   * Déconnecter l'utilisateur
   */
  logout(): void {
    this.currentUserSubject.next(null);
    localStorage.removeItem('currentUser');
  }

  /**
   * Obtenir le nom d'affichage de l'utilisateur
   */
  getDisplayName(): string {
    const user = this.currentUserSubject.value;
    return user?.displayName || user?.username || 'Utilisateur';
  }
}
